module.exports = __webpack_public_path__ + "assets/img/bg.e84ad597.png";